var group_sortable1=null;
var group_sortable2=null;

/**
 * Funcionalitat edicio nom del mapa
 * */
function addFuncioRenameMap(){
	$('.nomAplicacio.editable').editable({
		type: 'text',
		mode: 'inline',
		display: function(value, response){
			$(this).html(InstamapsUtils.Getters.shortString(value,51));
			$(this)[0].title=value;
		},
		validate: function(value) {
			if($.trim(value) == '') {
				return {newValue: this.innerHTML};
			}
		},
		success: function(response, newValue) {
			var data = {
				businessId: url('?businessid'),
			 	nom: newValue,
			 	uid: Cookies.get('uid')
			}
			updateMapName(data).then(function(results){
				//$.publish('analyticsEvent',{event:['mapa', tipus_user+'editar nom aplicacio', 'label editar nom', 1]});
				if(results.status=='OK'){
					mapConfig.nomAplicacio = results.results;
					$('#dialgo_publicar #nomAplicacioPub').val(mapConfig.nomAplicacio);
					$('#dialog_info_attribution').find('.modal-title').html(mapConfig.nomAplicacio);
					$('.nomAplicacio.editable').editable('setValue', mapConfig.nomAplicacio);
				}
			},function(results){
				$('.nomAplicacio.editable').editable('setValue', mapConfig.nomAplicacio);
			});
		}
	});
}

function reOrderGroupsAndLayers(action){
	var z_order=-1,
	_groupName, 
	_groupId, 
	_groupSubId, 
	_businessId, 
	_expanded;
	
	$("div.leaflet-control-accordion-layers").each(function( index, element ) {
		var $this = $(this);
		var gr=$this.children("label").children('span.span_ac');
		_groupId=index;
		_groupName=gr.text();
		var _exp=$this.children("label").children('i.label_gl');
		var _id=$(_exp).attr("id");
		_expanded=true;
		if($('#'+_id).hasClass('glyphicon-triangle-right')){
			_expanded=false;
		}
		$this.children("ol.ac-large").children("li.leaflet-row").each(function(){
			$this; // parent li
			_businessId=this.id.replace("LI-",""); // child li
			z_order=z_order+1;
			
			if(action){
				controlCapes.updateTreeGroupLayers(_groupId,_groupName,_businessId,z_order,_expanded).then(function(resp_Layer){
				if(resp_Layer){
					var data = {
						mapBusinessId: url('?businessid'),
						businessId: resp_Layer.options.businessId, //url('?businessid')
						uid: Cookies.get('uid'),
						options: JSON.stringify(resp_Layer.options.group)
					 };
					
					var data2 = {
						servidorWMSbusinessId:resp_Layer.options.businessId,
						businessId:url('?businessid'), //url('?businessid')
						uid: Cookies.get('uid'),
						order: z_order
					 };
		
					updateGroupsLayerGroup(data,data2);
				}
				});
			}
		});
	});
}

function updateGroupsLayerGroup(data,data2){
	updateServidorWMSGroup(data).then(function(results){
		if(results.status==='OK'){
			if(data2){
				//TODO validar si es necesario hacer esta llamada
				updateServerOrderToMap(data2).then(function(results) {
					if (results.status != 'OK')
						return;// SI no ha anat be el canvi a BD. que
								// no es faci tampoc a client, i es
								// mostri un error
				}, function(results) {
					return;// SI no ha anat be el canvi a BD. que no es
							// faci tampoc a client, i es mostri un
							// error
				});
			}
		}
	});
}

function refreshSortablesElements(){
	updateSortablesElements();
}

function updateSortablesElements(){
	if(InstamapsUtils.Validator.isModeMapa($(location).attr('href'))){
		group_sortable1 = $("ol.leaflet-control-layers-overlays").sortable({
			connectWith: "ol.leaflet-control-layers-overlays",
			handle: ".label_ac", //hadle para el drag issue 540
			change: function( event, ui ) {
				setTimeout(function(){ reOrderGroupsAndLayers(true); }, 1000);
			}
		});

		group_sortable2 = $("ol.ac-large").sortable({
			connectWith: "ol.ac-large",
			stop: function( event, ui ) {
				reOrderGroupsAndLayers(true);
			}
		});
	}
}


/**
 * Funcionalitats edicio noms capes
 * */
function updateEditableElements(){
	$('.label_ac .editable').editable({
		type: 'text',
		mode: 'inline',
		validate: function(value) {
			if($.trim(value) == '') {
				return {newValue: this.innerHTML};
			}
		},
		success: function(response, newName) {
			var oldName=this.groupName;
			var resp_Layer=	controlCapes.updateGroupName(oldName,newName,this.groupId);
			for(i=0;i < resp_Layer.length;i++){
				var data = {
					mapBusinessId: url('?businessid'),
				 	businessId: resp_Layer[i].options.businessId, //url('?businessid')
				 	uid: Cookies.get('uid'),
				 	options: JSON.stringify(resp_Layer[i].options.group)
				 };
				updateGroupsLayerGroup(data,null);
			}
		}
	});

	 $('.label_ac .editable').on('shown', function(e, editable) {
		 jQuery('.group-conf').hide();
	 });
		
	 $('.label_ac .editable').on('hidden', function(e, editable) {
		 jQuery('.group-conf').show();
	 });

	 $('.leaflet-name .editable').editable({
		 type: 'text',
		 mode: 'inline',
		 validate: function(value) {
			 if($.trim(value) == '') {
				 return {newValue: this.innerHTML};
			 }
		 },
		 success: function(response, newValue) {
			InstamapsUtils.Mapa.closePopup(jQuery, map);//Perque no queden desactualitzats
			 var id = this.id;
			 var idParent = this.idParent;
			 //Controlem si es sublayer
			 var editableLayer;
			 if(idParent){
				 editableLayer = controlCapes._layers[this.idParent]._layers[this.id];
			 }else{
				 editableLayer = controlCapes._layers[this.id];
			 }
			 var data = {
				businessId: editableLayer.layer.options.businessId, //url('?businessid')
				uid: Cookies.get('uid'),
				serverName: newValue
			 };
			 var oldName = this.innerHTML;
			 
			 updateServidorWMSName(data).then(function(results){
				 if(results.status==='OK'){
					 //$.publish('analyticsEvent',{event:['mapa', tipus_user+'editar nom capa', 'label editar nom', 1]});
					//Actualitzem popup de les geometries de la capa
					InstamapsUtils.Mapa.closePopup(jQuery, map);

					//Cal modificar la propietat capaNom de totes les layers
					for(indexSublayer in editableLayer.layer._layers){
						var sublayer = editableLayer.layer._layers[indexSublayer];
						sublayer.properties.capaNom = newValue;
						if (sublayer.properties.feature !== undefined) {
							sublayer.properties.feature.properties.capaNom = newValue;	
						}
					}	

					 var layerName=newValue;			
				    	(layerName.length > 71)?layerName=layerName.substring(0,71)+"...":layerName;		
				    
					 //editableLayer.name = newValue;
				     editableLayer.name = layerName;	
					 editableLayer.layer.options.nom = newValue;
					 $('.leaflet-name label span#'+id).text(layerName);
					 if(editableLayer.layer.options.businessId == $("#mapLegendEdicio").data("businessid")){
						 $(".titol-legend").html(newValue);
					 }
					 map.fire('onRedrawLegend', mapConfig);
					 map.fire('activaLegendTab',{id: editableLayer.layer.options.businessId, activo: true, name: newValue});
				 }else{
					 editableLayer.name = oldName;
					 $('.leaflet-name label span#'+id).text(results.results.nom);
				 }
			 },function(results){
				 editableLayer.name = oldName;
				 var obj = $('.leaflet-name label span#'+id).text();
				 $('.leaflet-name label span#'+id).text(oldName);
			 });
		 }
	 });

	 $('.leaflet-name .editable').on('shown', function(e, editable) {
		 jQuery('.opcio-conf').hide();
		 jQuery('.subopcio-conf').hide();
	 });
	 $('.leaflet-name .editable').on('hidden', function(e, editable) {
		 jQuery('.opcio-conf').show();
	 });
}

/**
 * Funcionalitat de descarrega de capes
 * */
function addFuncioDownloadLayer(from){
	addHtmlModalDownloadLayer(from);
}

/**
 * Funcionalitat remove layers
 **/
function removeAtomicLayer(data,matriuObj){
	
	removeServerToMap(data).then(function(results){
		if(results.status==='OK'){
			for(var j=0; j < matriuObj.length;j++){
			var obj=matriuObj[j];
			InstamapsUtils.Mapa.closePopup(jQuery, map);
			map.eachLayer( function(layer) {
				if (layer.properties!==undefined && layer.properties.capaBusinessId!==undefined) {
					if (obj.layer.options!==undefined && obj.layer.options.businessId!==undefined) {
						if (layer.properties.capaBusinessId === obj.layer.options.businessId)	{
							map.removeLayer(layer);
						}	
					}				
				}
			});		
			try{
				obj.layer.clearLayers();
			}catch(e){

			}
			
			map.removeLayer(obj.layer);
			//Eliminem la capa de controlCapes
			controlCapes.removeLayer(obj);
			//Esborrem la llegenda de la capa eliminada
			////emptyMapLegendEdicio(obj.layer);
			//actualitzem valors zindex de la resta si no es sublayer
			if(!obj.sublayer){
				var removeZIndex = obj.layer.options.zIndex;
				controlCapes._lastZIndex--;
				var aux = controlCapes._layers;
				for (var i in aux) {
					if (aux[i].layer.options.zIndex > removeZIndex) aux[i].layer.options.zIndex--;
				}
				//Eliminem les seves sublayers en cas que tingui
				for(indexSublayer in obj._layers){
					map.removeLayer(map._layers[indexSublayer]);
				}
			}
			else {
				if(obj.sublayer){
					deleteServidorWMS(data).then(function(results){
						console.debug(results);
					});
				}
			}

			//Actualitzem capaUsrActiva
			if(capaUsrActiva!=null && capaUsrActiva.options.businessId == obj.layer.options.businessId){
				capaUsrActiva.removeEventListener('layeradd');
				capaUsrActiva = null;
			}

			//actualizar servidorswms del mapconfig
			mapConfig.servidorsWMS = InstamapsUtils.Mapa.actualitzarServidorsWMS(obj.layer.options.businessId,"baixa",null,null,mapConfig.servidorsWMS);
			}
			controlCapes.forceUpdate(true);
			
		}else{
			return;//SI no ha anat be el canvi a BD. que no es faci tampoc a client, i es mostri un error
		}
	},function(results){
		return;//SI no ha anat be el canvi a BD. que no es faci tampoc a client, i es mostri un error
	});
}

function addFuncioRemoveLayer(){
	addHtmlModalRemoveLayer();
	addHtmlModalRemoveGroup();
}

/**
 * Funcionalitat addToolTips Panell de capes
 **/
function addTooltipsConfOptions(businessId){

	$(".conf-"+businessId+".leaflet-up").tooltip({
		placement : 'bottom',
		container : 'body',
		title : window.lang.translate("puja")
	});

	$(".conf-"+businessId+".leaflet-down").tooltip({
		placement : 'bottom',
		container : 'body',
		title : window.lang.translate("baixa")
	});

	$(".conf-"+businessId+".leaflet-remove").tooltip({
		placement : 'bottom',
		container : 'body',
		title : window.lang.translate("elimina")
	});

	$(".conf-"+businessId+".leaflet-download").tooltip({
		placement : 'bottom',
		container : 'body',
		title : window.lang.translate("descarrega")
	});

	$(".conf-"+businessId+".leaflet-data-table").tooltip({
		placement : 'bottom',
		container : 'body',
		title : window.lang.translate("dades")
	});

	$(".remove-conf").tooltip({
		placement : 'bottom',
		container : 'body',
		title : window.lang.translate("elimina")
	});

	$(".duplicate-conf").tooltip({
		placement : 'bottom',
		container : 'body',
		title : window.lang.translate("duplicar")
	});
}

function addFuncioEtiquetesCapa(){
	addHtmlModalEtiquetesLayer();
}

function addFuncioDuplicateLayer(){
	$.get("static/geocatweb/templates/modalDuplicateLayer.html",function(data){
		//TODO ver como pasar el modal container
		$('#mapa_modals').append(data);  
		$('#bt_duplicate_layer').on('click', function(evt){
			map.spin(true);
			var data = {
					businessId: $('#modal_duplicate_layer #businessId_duplicar').val(),//capa a duplicar
					uid: Cookies.get('uid'),
					mapBusinessId: url('?businessid'), //businessId del mapa
					nom:$('#modal_duplicate_layer #nom_capa_duplicar')[0].value+"_duplicat" //nom capa nova
			};
			//mètode per duplicar capes "temàtiques" i convertir-les en visualitzacions
			duplicateFromTematicToVisualitzacioLayer(data).then(function(results){
					loadVisualitzacioLayer(results.results).then(function(results1){
						map.spin(false);
						if(results1 && !jQuery.isEmptyObject(results1._layers)){
							map.fitBounds(results1.getBounds());
						}
						InstamapsUtils.Mapa.activaPanelCapes(true, jQuery);
						if(InstamapsUtils.Validator.isModeMapa($(location).attr('href'))){
								updateSortablesElements();
						}
					});
					
								
			});
		});
	});	

	
}

function addHtmlModalDownloadLayer(from){
	$.get("/static/geocatweb/templates/modalDownloadLayer.html",function(data){
		//TODO ver como pasar el modal container
		$('#mapa_modals').append(data);
		
		//Si la capa conté polígons no es podrà descarregar en format GPX
		$('#modal_download_layer').on('show.bs.modal', function (e) {
			  if((download_layer.layer!=undefined && download_layer.layer.options.geometryType
					  && download_layer.layer.options.geometryType==t_polygon) || 
					  (download_layer.options!=undefined && download_layer.options.geometryType
						&& download_layer.options.geometryType==t_polygon)){
				  $("#select-download-format option[value='GPX#.gpx']").attr('disabled','disabled');
			  }else{
				  $("#select-download-format option[value='GPX#.gpx']").removeAttr('disabled');
			  }

			  //Reset the modal values
			  $("#input-download-name").val("");
			  $("#select-download-format").val($("#select-download-format option:first").val());
			  $("#select-download-epsg").val($("#select-download-epsg option:first").val());
		});

		jQuery('#select-download-format').change(function() {
			var ext = jQuery(this).val();
			if ((ext=="KML#.kml")||(ext=="GPX#.gpx")){
			jQuery("#select-download-epsg").val("EPSG:4326").attr('disabled',true);
			}else{
				jQuery("#select-download-epsg").attr('disabled',false);
			}
		});

		$('#bt_download_accept').on('click', function(evt){
			var formatOUT = $('#select-download-format').val();
			var epsgOUT = $('#select-download-epsg').val();
			var filename = $('#input-download-name').val();
			var layer_GeoJSON = null;
			var download_layer1 = null;
			if (download_layer != undefined){
				if (download_layer.layer != undefined){
					layer_GeoJSON = download_layer.layer.toGeoJSONcustom();
				}
				else {
					var viewer_vue = getInstamapsMapViewer();
					var _layers = viewer_vue.layersLeaflet;
					jQuery.each(_layers, function(i, lay){
						if (lay.businessId !== undefined &&  download_layer.businessId === lay.businessId) {
							download_layer1 = lay.layer;
						}
					});
					layer_GeoJSON = download_layer1.toGeoJSONcustom();
				}
			}
			

			var data = {
				cmb_formatOUT: formatOUT,
				cmb_epsgOUT: epsgOUT,
				layer_name: filename,
				fileIN: JSON.stringify(layer_GeoJSON)
			};

			//$.publish('analyticsEvent',{event:[from, tipus_user+'descarregar capa', formatOUT+"-"+epsgOUT, 1]});

			getDownloadLayer(data).then(function(results){
				results = results.trim();
				if (results == "ERROR"){
					$('#modal-body-download-error').show();
					$('#modal-body-download').hide();
					$('#modal_download_layer .modal-footer').hide();
					$('#modal_download_layer').modal('show');
				}else{
					var iframe = $("#downloadFrame");
					if(0 == iframe.length)
					{

						iframe = $("<iframe/>").attr({
							id: "downloadFrame",
							style: "visibility:hidden;display:none"
						}).appendTo('#modal_download_layer');
					}
					
					iframe.attr("src", GEOCAT02 + results)

				}
			},function(results){
				$('#modal-body-download-error').show();
				$('#modal-body-download').hide();
				$('#modal_download_layer .modal-footer').hide();
				$('#modal_download_layer').modal('show');
			});

		});
		
	});
}

function addHtmlModalRemoveLayer(){
	$.get("static/geocatweb/templates/modalRemoveLayer.html",function(data){
		//TODO ver como pasar el modal container
		$('#mapa_modals').append(data);  
		
		$('#dialog_delete_capa .btn-danger').on('click', function(event){
			var $this = $(this);
			var data = $this.data("data");
			var obj = $this.data("obj");
			var matriuObj=[];
			matriuObj.push(obj);
			removeAtomicLayer(data,matriuObj);
		});
	});
}

function addHtmlModalRemoveGroup(){
	$.get("static/geocatweb/templates/modalRemoveGroup.html",function(data){
		//TODO ver como pasar el modal container
		$('#mapa_modals').append(data); 
		
		//Esborra grup capes
		$('#dialog_delete_group .btn-danger').on('click', function(event){
			var $this = $(this);
			var group = $this.data("group");
			var matriuCapesGroup=controlCapes.getLayersFromGroupId(group.groupId,group.groupName);
			var lbusinessId = [];
			var matriuObj=[];
				for(i=0; i < matriuCapesGroup.length;i++){
					var obj;
					var layerIdParent = matriuCapesGroup[i].layerIdParent;
					if(!layerIdParent){
						obj = matriuCapesGroup[i];
						lbusinessId.push(obj.layer.options.businessId);
						for(j in obj._layers){
							lbusinessId.push(obj._layers[j].layer.options.businessId);
						}
					}else{
						obj =matriuCapesGroup[i];
						lbusinessId.push(obj.layer.options.businessId);
					}
					matriuObj.push(obj);
					if(!obj.overlay) {
						return;
					}
				}

				if(typeof url('?businessid') == "string"){
					var data = {
						businessId: url('?businessid'),
						uid: Cookies.get('uid'),
						servidorWMSbusinessId:lbusinessId.toString()
					};
					removeAtomicLayer(data,matriuObj);
				}

				controlCapes.removeGroup(group.groupName,group.groupId);
				if (controlCapes._visLayers!==undefined) controlCapes._visLayers = {};
				InstamapsUtils.Mapa.closePopup(jQuery, map);
		});
	});
}

function addHtmlModalEtiquetesLayer(){
	$.get("static/geocatweb/templates/modalEtiquetesLayer.html",function(data){
		//TODO ver como pasar el modal container
		$('#mapa_modals').append(data); 
		
		$('.make-switch').bootstrapSwitch();
		
		$('#colorpalette_etiqueta').colorPalette().on('selectColor', function(e) {   	
			$('#dv_color_etiqueta').css('background-color',e.color);		
		});
		
		$('#colorpalette_caixa_etiqueta').colorPalette().on('selectColor', function(e) {   	
			$('#dv_color_caixa_etiqueta').css('background-color',e.color);		
		});
		
		$('input[name="addLabel"]').on('switchChange.bootstrapSwitch', function(event, state) {
    		if(state.value == true) {
    			$('#div_addLabel').attr("style","display:block;");
    		}
    		else {
    			$('#div_addLabel').attr("style","display:none;");
    			$('input:radio[name=etiqueta][value=geometries]').attr('checked', true);
    			$('#dataFieldEtiqueta option[value=---]').attr('selected','selected');
				
    		}
		});
		
	
	});
}

function addFuncioInfoLayer(){
		$.get("static/geocatweb/templates/modalInfoLayer.html",function(data){
			//TODO ver como pasar el modal container
			$('#mapa_modals').append(data);  
		
		});	
}
